import React from 'react'
import { Text, Text3 } from '../common'
import InfoRoundedIcon from '@mui/icons-material/InfoRounded'
import { Box, Stack, alpha } from '@mui/material'

import Modal2 from '@/components/Modal2'

interface ConfirmInvoiceModalProps {
  data: any
  open: boolean
  onOk: () => void
  onCancel: () => void
  isSpecialInvoice: boolean
}

const ConfirmInvoiceModal: React.FC<ConfirmInvoiceModalProps> = ({ open, isSpecialInvoice, onCancel, data, onOk }) => {
  const infoList: any[] = [
    { label: '名称', value: data.unit_name },
    { label: '统一社会信用代码 / 纳税人识别号', value: data.taxpayer_id },
    {
      label: '单位地址',
      value: data.unit_address,
    },
    { label: '开户银行', value: data.bank_name },
    { label: '银行账户', value: data.bank_account },
    isSpecialInvoice && { label: '联系电话', value: data.phone },
  ].filter(Boolean)
  return (
    <Modal2 title='确认信息' width={800} okText='提交' showCancel={false} open={open} onCancel={onCancel} onOk={onOk}>
      <Stack
        direction='row'
        gap={1}
        sx={(theme) => {
          return {
            py: 1,
            px: 2,
            backgroundColor: alpha(theme.palette.primary.main, 0.1),
            fontSize: 14,
            alignItems: 'center',
            marginBottom: 2,
            borderRadius: 1,
          }
        }}
      >
        <InfoRoundedIcon sx={{ color: 'primary.main', fontSize: 20 }} />
        <Box>发票再申请流程复杂，请再次确认发票填写信</Box>
      </Stack>
      <Stack gap={3} sx={{ backgroundColor: 'rgba(242, 243, 245, 0.5)', borderRadius: 1, p: 2 }}>
        {infoList.map((item, index) => (
          <Stack direction='row' gap={3} key={index}>
            <Text3 sx={{ width: 126, flexShrink: 0 }}>{item.label}</Text3>
            <Text sx={{ fontSize: 14 }}>{item.value || '-'}</Text>
          </Stack>
        ))}
      </Stack>
    </Modal2>
  )
}

export default ConfirmInvoiceModal
